import { render, staticRenderFns } from "./MergedLinkPopup.vue?vue&type=template&id=ed8a4398"
import script from "./MergedLinkPopup.vue?vue&type=script&lang=js"
export * from "./MergedLinkPopup.vue?vue&type=script&lang=js"
import style0 from "./MergedLinkPopup.vue?vue&type=style&index=0&id=ed8a4398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports